export default __webpack_public_path__ + "static/logo-freshcells-systems-engineering-inverted-788b5c1c0df7fda39b6adef251059d2b.svg";